function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(.931 .711)"
}, React.createElement("path", {
  fill: "#EDE85A",
  d: "M20.994 3.652a4.564 4.564 0 0 1 4.563 4.563v13.692a1.825 1.825 0 1 0 3.651 0V8.215A8.215 8.215 0 0 0 20.994.001v3.65z"
}), React.createElement("path", {
  fill: "#EDC333",
  d: "M20.994 1.826c-.002 0-.003.004-.004.004v-.004a.909.909 0 0 0 0 1.818v-.02l.004.028a4.564 4.564 0 0 1 4.563 4.563v13.692a.913.913 0 0 0 1.826 0V8.215c-.171-5.847-5.22-6.389-6.39-6.389z"
}), React.createElement("path", {
  fill: "#00AB6F",
  d: "M1.07 12.336L12.336 1.069a3.651 3.651 0 0 1 5.163 0l19.768 19.768a3.651 3.651 0 0 1 0 5.164L26.001 37.267a3.651 3.651 0 0 1-5.164 0L1.07 17.499a3.651 3.651 0 0 1 0-5.163z"
}), React.createElement("path", {
  fill: "#00965C",
  d: "M14.917 0a3.64 3.64 0 0 0-2.581 1.07l-.484.484-1.277 1.276-1.804 1.805-2.068 2.068-2.069 2.068-1.804 1.805-1.277 1.276-.484.484a3.651 3.651 0 0 0 0 5.164l3.304 3.303a.913.913 0 0 0 1.29-1.29L2.36 16.208a1.828 1.828 0 0 1 0-2.582L13.626 2.361a1.814 1.814 0 0 1 1.291-.535.913.913 0 0 0 0-1.825z"
}), React.createElement("ellipse", {
  cx: 18.883,
  cy: 18.883,
  fill: "#007A3F",
  rx: 4.623,
  ry: 6.196,
  transform: "rotate(-135 18.883 18.883)"
}), React.createElement("path", {
  fill: "#FFB100",
  d: "M13.405 4.278l-3.65 3.651v1.826l3.65 3.65h1.826l3.65-3.65V7.929l-3.65-3.651z"
}), React.createElement("g", {
  fill: "#B3E6D4"
}, React.createElement("path", {
  d: "M21.086 10.134v-.001a1.29 1.29 0 0 1 1.825 0l4.721 4.72a1.29 1.29 0 0 1-1.825 1.825l-4.721-4.72a1.29 1.29 0 0 1 0-1.824zM28.388 17.435a1.29 1.29 0 0 1 1.825 0l2.896 2.894a1.29 1.29 0 0 1 0 1.825h-.001a1.29 1.29 0 0 1-1.825 0l-2.895-2.894a1.29 1.29 0 0 1 0-1.825zM4.656 11.959a1.29 1.29 0 0 1 1.825 0l1.07 1.07a1.29 1.29 0 0 1-1.825 1.825l-1.07-1.07a1.29 1.29 0 0 1 0-1.825zM8.307 15.609a1.29 1.29 0 0 1 1.825 0l1.07 1.07a1.29 1.29 0 0 1-1.825 1.825l-1.07-1.07a1.29 1.29 0 0 1 0-1.825zM11.958 19.26a1.29 1.29 0 0 1 1.825 0l1.07 1.07a1.29 1.29 0 0 1-1.825 1.825l-1.07-1.07a1.29 1.29 0 0 1 0-1.824zM15.609 22.912a1.29 1.29 0 0 1 1.825 0l1.07 1.07a1.29 1.29 0 0 1-1.825 1.825l-1.07-1.07a1.29 1.29 0 0 1 0-1.825z"
})), React.createElement("path", {
  fill: "#E95F00",
  d: "M13.908 20.081h21.879a3.651 3.651 0 0 1 3.592 4.304l-2.323 12.779a3.651 3.651 0 0 1-3.592 2.998H17.393a3.651 3.651 0 0 1-3.522-2.69l-3.485-12.78a3.651 3.651 0 0 1 3.522-4.61z"
}), React.createElement("path", {
  fill: "#E14C00",
  d: "M38.336 25.558a1.825 1.825 0 0 1-1.825 1.825h-3.93c-.893 0-1.655.645-1.801 1.526l-1.213 7.277a2.574 2.574 0 1 1-5.036-1.047l2.506-10.024a1.825 1.825 0 0 1 1.771-1.383h7.702c1.009 0 1.826.818 1.826 1.826z"
}), React.createElement("path", {
  fill: "#FFB100",
  d: "M4.375 20.081h20.459a3.651 3.651 0 0 1 3.592 4.304l-2.324 12.779a3.651 3.651 0 0 1-3.592 2.998H6.698a3.651 3.651 0 0 1-3.592-2.998L.783 24.385a3.651 3.651 0 0 1 3.592-4.304z"
}), React.createElement("path", {
  fill: "#FF9B00",
  d: "M3.651 23.733h21.907a1.825 1.825 0 0 1 0 3.651H3.65a1.825 1.825 0 1 1 0-3.651z"
}), React.createElement("g", {
  fill: "#E95F00"
}, React.createElement("path", {
  d: "M7.302 27.383c1.008 0 1.825.817 1.825 1.826v5.476a1.825 1.825 0 1 1-3.651 0V29.21c0-1.009.818-1.826 1.826-1.826zM14.605 27.383c1.008 0 1.825.817 1.825 1.826v5.476a1.825 1.825 0 1 1-3.651 0V29.21c0-1.009.817-1.826 1.826-1.826zM21.906 27.383c1.009 0 1.826.817 1.826 1.826v5.476a1.825 1.825 0 1 1-3.651 0V29.21c0-1.009.817-1.826 1.825-1.826z"
})), React.createElement("path", {
  fill: "#FF7E00",
  d: "M11.866 20.081h25.558a2.738 2.738 0 0 1 0 5.477H11.866a2.738 2.738 0 0 1 0-5.477z"
}), React.createElement("path", {
  fill: "#FFD300",
  d: "M2.738 20.081h25.558a2.738 2.738 0 0 1 0 5.477H2.738a2.738 2.738 0 0 1 0-5.477z"
}), React.createElement("path", {
  fill: "#FFE04C",
  d: "M5.477 20.081h20.08a1.825 1.825 0 1 1 0 3.651H5.477a1.825 1.825 0 1 1 0-3.651z"
}), React.createElement("path", {
  fill: "#FFBF00",
  d: "M2.738 23.733h25.558a.913.913 0 0 1 0 1.826H2.738a.913.913 0 1 1 0-1.826z"
}), React.createElement("path", {
  fill: "#FFAB00",
  d: "M16.43 20.081c1.008 0 1.825.818 1.825 1.826v1.825a1.825 1.825 0 1 1-3.651 0v-1.825c0-1.008.818-1.826 1.826-1.826z"
}), React.createElement("path", {
  fill: "#EDE85A",
  d: "M29.208 8.215a8.215 8.215 0 0 0-16.43 0v13.692a1.826 1.826 0 0 0 3.652.001V8.215a4.564 4.564 0 0 1 9.128 0h3.65z"
}), React.createElement("path", {
  fill: "#EDC333",
  d: "M20.994 1.826c-.002 0-.003.004-.004.004v-.004a.909.909 0 0 0 0 1.818v-.02l.004.028a4.564 4.564 0 0 1 4.563 4.563h1.826c-.171-5.847-5.22-6.389-6.39-6.389z"
}), React.createElement("path", {
  fill: "#FF6900",
  d: "M31.947 23.733h5.476a.913.913 0 0 1 0 1.826h-5.476a.913.913 0 1 1 0-1.826z"
}), React.createElement("path", {
  fill: "#E14C00",
  d: "M28.295 38.336h5.477a.913.913 0 1 1 0 1.826h-5.477a.913.913 0 1 1 0-1.826z"
}), React.createElement("path", {
  fill: "#FF9A38",
  d: "M32.86 20.081h3.65a1.825 1.825 0 1 1 0 3.651h-3.65a1.825 1.825 0 1 1 0-3.651z"
}), React.createElement("path", {
  fill: "#D03C03",
  d: "M6.39 29.21c.503 0 .912.408.912.912v3.65a.913.913 0 0 1-1.825 0v-3.65c0-.504.408-.913.912-.913z"
}), React.createElement("g", {
  fill: "#FFD300"
}, React.createElement("path", {
  d: "M10.04 29.21c.505 0 .913.408.913.912v3.65a.913.913 0 0 1-1.826 0v-3.65c0-.504.41-.913.913-.913zM17.342 29.21c.504 0 .913.408.913.912v3.65a.913.913 0 0 1-1.826 0v-3.65c0-.504.41-.913.913-.913zM24.645 29.21c.504 0 .913.408.913.912v3.65a.913.913 0 0 1-1.826 0v-3.65c0-.504.409-.913.913-.913z"
})), React.createElement("g", {
  fill: "#D03C03"
}, React.createElement("path", {
  d: "M13.692 29.21c.504 0 .913.408.913.912v3.65a.913.913 0 0 1-1.826 0v-3.65c0-.504.409-.913.913-.913zM20.994 29.21c.504 0 .912.408.912.912v3.65a.913.913 0 0 1-1.826 0v-3.65c0-.504.41-.913.914-.913z"
})), React.createElement("path", {
  fill: "#FF9B00",
  d: "M6.39 38.336h16.428a.913.913 0 1 1 0 1.826H6.39a.913.913 0 1 1 0-1.826z"
}));

var SvgGroceries = function SvgGroceries(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGroceries, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/groceries.837d2c75.svg";
export { ForwardRef as ReactComponent };